var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.title
      ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
          _c("h3", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _vm.generatedCtaLink
            ? _c(
                "a",
                {
                  staticClass: "ml-auto my-auto link-arrow",
                  attrs: { href: _vm.generatedCtaLink }
                },
                [
                  _vm._v(_vm._s(_vm.cta) + " "),
                  _c("span", {
                    staticClass: "arrow-right",
                    domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                  })
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "d-block position-relative",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.toggleSlideout($event)
          }
        }
      },
      [
        _c("div", { staticClass: "mx-n24 mx-md-0" }, [
          _c("div", { staticClass: "tribe-box-banner" }, [
            _vm.tribeBox.acf.image
              ? _c("img", {
                  attrs: {
                    src: _vm.tribeBox.acf.image.url,
                    alt: _vm.tribeBox.post_title
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("h2", { staticClass: "mb-8 text-white title" }, [
                _vm._v(_vm._s(_vm.tribeBox.post_title))
              ]),
              _vm._v(" "),
              _vm.tribeBox.acf.description
                ? _c("div", {
                    staticClass: "text-white font-weight-light description",
                    domProps: {
                      innerHTML: _vm._s(_vm.tribeBox.acf.description)
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "btn btn-accent mt-24 align-self-start" },
                [
                  _vm._v("Vraag offerte aan "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.svg("arrow-right", "arrow-right"))
                    }
                  })
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }